/**
 * Hard limit for the reconciliation file. Kept in sync with the kipey-core
 * contract; step 1 of the direct upload flow (`/purchase/file/upload/sas`)
 * returns the authoritative `maxSizeBytes`, which always wins over this value.
 */
export const PURCHASE_FILE_MAX_SIZE_BYTES = 400 * 1024 * 1024;

export const PURCHASE_FILE_ALLOWED_MIME_TYPES: string[] = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv',
  'application/csv',
];

/**
 * Some operating systems report an empty `File.type` for `.csv`. Azure Blob
 * Storage still requires a `Content-Type` on the PUT, so fall back to a
 * generic binary type instead of sending an empty header.
 */
export const PURCHASE_FILE_FALLBACK_CONTENT_TYPE = 'application/octet-stream';
